import { render, staticRenderFns } from "./Landpage.vue?vue&type=template&id=3937a83a&scoped=true&"
import script from "./Landpage.vue?vue&type=script&lang=js&"
export * from "./Landpage.vue?vue&type=script&lang=js&"
import style0 from "./Landpage.vue?vue&type=style&index=0&id=3937a83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937a83a",
  null
  
)

export default component.exports